export default __webpack_public_path__ + "static/media/2.68a35b52.jpg";